<template>
    <div class="text-vote">
        <div class="title">{{title}}</div>
        <!-- 2选项 -->
        <div v-if="isTwoOption" class="two-options">
            <!-- 未投票 && 未结束 -->
            <div class="two-un-voted" v-if="!isVoted&&!isFinish">
                <div class="option" v-for="item in options" :key="item.id" @click.stop="goToVote(item)">{{item.name}}</div>
            </div>
            <!-- 已结束 || 已投票 -->
            <div class="two-finished" v-if="isFinish || isVoted">
                <div class="option-name">
                    <div class="left-c"  @click.stop="goToVote(options[0])">
                        <div 
                            v-if="userOptionId == options[0].id" 
                            :class="getSelectedIconClass(0)"
                        />
                        <div class="left-name" :style="{color: isFinish?'#999':'#4A70FF'}">
                            {{options[0].name}} {{options[0].percent}}%
                        </div>
                    </div>
                    <div class="right-c"  @click.stop="goToVote(options[1])">
                        <div class="right-name" :style="{color: isFinish?'#CCC':'#FF5E4D'}">
                            {{options[1]&&options[1].name}} {{options[1].percent}}%
                        </div>
                        <div 
                            v-if="userOptionId == options[1].id" 
                            :class="getSelectedIconClass(1)"
                        />
                    </div>
                </div>
                <div class="result-bar" :style="getBarStyle()">
                </div>
            </div>
        </div>
        <!-- 大于2个选项 -->
        <div v-else class="mul-options">
            <div v-for="item in options" :key="item.id">
                <!-- 未投票 && 未结束 -->
                <div v-if="!isVoted&&!isFinish" class="vote-1" @click.stop="goToVote(item)">{{item.name}}</div>
                <div 
                    v-else 
                    @click.stop="goToVote(item)"
                    :class="[isFinish?'vote-3':userOptionId==item.id?'vote-2':'vote-3']" 
                    :style="{'--percent':item.percent+'%'}"
                >   
                    <div class="left-c">
                        <div class="name">{{item.name}}</div>
                        <div 
                            v-if="userOptionId==item.id" 
                            :class="getSelectedIconClass(0)"
                            />
                    </div>
                    <div class="percent">{{item.percent}}%</div>
                </div>
            </div>
        </div>
        <!-- 提示信息 -->
        <Tips :fields="fields" :isFinish="isFinish"/>
    </div>
</template>
<script>
import Tips from './tips.vue'

export default {
    props: ['fields','isFinish'],
    components: {
        Tips
    },
    data() {
        return {
        }
    },
    computed: {
        title() {
            return this.fields?.title
        },
        options() {
            return this.fields?.options
        },
        // 2个选项
        isTwoOption() {
            return this.options?.length == 2
        },
        // 多于2个选项
        isMulOption() {
            return !this.isTwoOption
        },
        // 已投票
        isVoted() {
            return this.fields?.userOptionId || false
        },
        // 已选选项
        userOptionId() {
            return this.fields?.userOptionId || ''
        },
    },
    mounted() {
    },
    methods: {
        getSelectedIconClass(flag) { // 0-left 1-right 
            if(this.isFinish){
                if( flag==0 )return ['select-left-icon','select-grey-img'] // 左选项
                return ['select-right-icon','select-grey-img'] // 右选项
            }
            if( flag == 0 ) return ['select-left-icon','left-select-img'] // 左选项
            return ['select-right-icon','right-select-img'] // 右选项
        },
        getBarStyle(){
            let p1 = this.options[0].percent
            let p2 = this.options[1].percent
            if(this.isFinish) {
                if(!p1&& !p2) p1 = 50
                return `background:linear-gradient(to right,#999 0%,#999 ${p1}%,#ccc ${p1}%,#ccc 100%;`
            }
            else return `background:linear-gradient(to right,#4A70FF 0%,#4A70FF ${p1}%,#FF5E4D ${p1}%,#FF5E4D 100%;`
        },
        goToVote(item) {
            this.$emit('sendVote',item)
        }
    }
}
</script>
<style lang="less" scoped>
.text-vote {
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
    background: #F8F8F8;
    border-radius: 4px; 
    padding: 20px; 
    font-family: PingFangSC, PingFang SC;
    margin-bottom: 20px;
    font-weight: 500;
    .title {
        font-weight: 600;
        font-size: 20px;
        color: #111111;
        line-height: 28px;
        text-align: left;
        font-style: normal;
    }
    .two-options {
        .two-un-voted {
            margin-top: 16px;
            height: 44px;
            width: 100%;
            background: url('../../../../images/discuss-btn-bg@2x.png') no-repeat center;
            background-size: 100% 100%;
            display: flex;
            .option {
                height: 100%;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 500;
                font-size: 14px;
                color: #FFFFFF;
            }
        }
        .two-finished {
            .option-name {
                display: flex;
                height: 20px;
                margin-top: 16px;
                justify-content: space-between;
                align-items: center;
                .left-c{
                    width: 50%;
                    display: flex;
                    align-items: center;
                    white-space: nowrap;
                    .left-name{
                        height: 20px;
                        font-size: 14px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        line-height: 20px;
                        margin-right: 8px;
                        max-width: 240px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
                .right-c{
                    width:50%;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    .right-name{
                        display: inline-block;
                        height: 20px;
                        font-size: 14px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        line-height: 20px;
                        margin-left: 8px;
                        max-width: 240px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
            .result-bar {
                margin-top: 8px;
                width:100%;
                height: 12px;
                border-radius: 4px;
            }
        }
    }
    .mul-options {
        margin-top: 20px;
        .vote-1 {
            margin-top: 8px;
            height: 44px;
            font-weight: 500;
            font-size: 14px;
            color: #111;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            border: 1px solid #EBEBEB;
            border-radius: 4px;
            background: white;
        }
        .vote-2 {
            margin-top: 8px;
            height: 44px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: 500;
            font-size: 14px;
            color: #4A70FF;
            padding-left: 19px;
            background:linear-gradient(to right,rgba(74,112,255,0.12) var(--percent),rgba(74,112,255,0.12) var(--percent),#fff var(--percent),#fff 100%);
            border-radius: 4px;
            border: 1px solid rgba(74,112,255,0.24);
            .left-c {
                display: flex;
                align-items: center;
                .name {
                    margin-right: 4px;
                }
            }
            .percent {
                margin-right:16px;
                font-weight: 500;
                font-size: 14px;
                color: #4A70FF;
            }
        }
        .vote-3 {
            margin-top: 8px;
            height: 44px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            
            font-size: 14px;
            color: #666;
            padding-left: 19px;
            background:linear-gradient(to right,#F2F2F2 var(--percent),#F2F2F2 var(--percent),#fff var(--percent),#fff 100%);
            border-radius: 4px;
            border: 1px solid #ebebeb;
            .left-c {
                .name {
                    margin-right: 4px;
                }
                display: flex;
                align-items: center;
            }
            .percent {
                margin-right:16px;
                font-weight: 500;
                font-size: 14px;
                color: #999;
            }
        }
    }
    .select-left-icon {
        display: inline-block;
        width:16px;
        height: 16px;
        margin-right: 4px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .select-right-icon {
        display: inline-block;
        width:16px;
        height: 16px;
        margin-left: 4px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .select-grey-img {
        background-image: url('../../../../images/icon_chose_grey@2x.png');
    }
    .left-select-img {
        background-image: url('../../../../images/icon_chose_blue@2x.png');
    }
    .right-select-img {
        background-image: url('//statics.itc.cn/mptc-mpfe/img/article/icon_vote_chose_b.png');
    }
}
</style>